import { DrawerBodyStyled } from 'app/Components/common/Drawer/styles';
import styled from 'styled-components';
import { Drawer } from '@insly/qmt-reactjs-ui-lib';

export const DrawerStyled = styled(Drawer)`
    top: 55px;
    display: flex;
    flex-direction: column;
`;

export const DrawerBodyAdmin = styled(DrawerBodyStyled)`
  padding-top: 10px;
`;

export const TeamsListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;  
`;

export const GroupStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid ${({ theme }) => theme.colors.strokeA};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 14px 16px;
  min-height: 60px;
`;

export const GroupStyledInner = styled.div`
  display: flex;
  gap: 10px;
`;

export const GroupStyledInnerMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

export const GroupName = styled.h4`
  ${({ theme }) => theme.text.headerH3}
`;

export const InputName = styled.span`
  ${({ theme }) => theme.text.tiny}
  color: ${({ theme }) => theme.colors.label}
`;

export const GroupControls = styled.div`
  display: flex;
  gap: 16px;
  padding-top: 10px;
  justify-content: end;
`;
